module.exports = __webpack_public_path__ + "static/img/9.3255c199.png";